const RIGHT_SPACING = 0.1;

export const optimizeHorizontalBarWidth = (width: number): string => `${width * (1 - RIGHT_SPACING)}%`;
